import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../services/api";
import AuthLayout from "../components/auth/AuthLayout";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords don't match"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setError("");
    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.error || "Reset failed. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout>
        <div className="text-center">
          <h1 className="text-[28px] font-bold text-gray-900 mb-4 font-body">Invalid Link</h1>
          <p className="text-[15px] text-gray-500 mb-6 font-body">This password reset link is invalid or has expired.</p>
          <Link to="/forgot-password" className="text-primary font-semibold hover:underline">Request a new one</Link>
        </div>
      </AuthLayout>
    );
  }

  if (done) {
    return (
      <AuthLayout>
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
          </div>
          <h1 className="text-[28px] font-bold text-gray-900 mb-2 font-body">Password Reset!</h1>
          <p className="text-[15px] text-gray-500 mb-6 font-body">Your password has been updated successfully.</p>
          <Link to="/login" className="inline-block px-8 py-3 bg-primary text-white rounded-lg font-semibold text-[15px] hover:bg-primary-dark transition-colors">Login Now</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <h1 className="text-[32px] font-bold text-gray-900 mb-2 font-body">Reset Password</h1>
      <p className="text-[15px] text-gray-500 mb-8 font-body">Enter your new password below</p>

      {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-[13px] text-red-600">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">New Password</label>
          <input type="password" placeholder="Enter new password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[14px] text-gray-700 placeholder-gray-400 outline-none focus:border-primary transition-colors font-body" />
        </div>
        <div className="mb-6">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Confirm Password</label>
          <input type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[14px] text-gray-700 placeholder-gray-400 outline-none focus:border-primary transition-colors font-body" />
        </div>
        <button type="submit" disabled={loading}
          className="w-full py-3 bg-primary text-white rounded-lg font-semibold text-[15px] hover:bg-primary-dark transition-colors font-body disabled:opacity-60">
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
